import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  result: undefined,
  error: undefined,
};

const change = (store, data) => {
  store.setState((state) => {
    state.admin.clientes.hits = {
      ...state.admin.clientes.hits,
      data: {
        ...state.admin.clientes.hits.data,
        ...data,
      },
    };
  });
};

const submit = async (store) => {
  store.setState((state) => {
    state.admin.clientes.hits.busy = true;
  });

  try {
    const data = { ...store.state.admin.clientes.hits.data };

    const response = await Http.post('/api/hits/clientes', data);

    store.setState((state) => {
      state.admin.clientes.hits = {
        ...state.admin.clientes.hits,
        data: {
          ...state.admin.clientes.hits.data,
          hits: undefined,
        },
        result: response,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.clientes.hits.error = error.data || error;
    });
  } finally {
    store.setState((state) => {
      state.admin.clientes.hits.busy = false;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.admin.clientes.hits = { ...initialState };
  });
};

const ClienteHitsAssignmentStore = {
  state: () => initialState,
  actions: {
    change,
    submit,
    reset,
  },
};

export default ClienteHitsAssignmentStore;
